/**
 * Wellness Product Template JavaScript
 */

// Replace logo on product pages - runs immediately to prevent visible replacement
(function replaceProductLogo() {
  'use strict';
  
  function replaceLogo() {
    const logoImage = document.querySelector('.logo__image');
    if (logoImage && !logoImage.dataset.replaced) {
      // Use Shopify asset path
      const logoSrc = '/assets/images/white-blue.png';
      logoImage.src = logoSrc;
      logoImage.setAttribute('src', logoSrc);
      logoImage.dataset.replaced = 'true';
      return true;
    }
    return false;
  }
  
  // Try to replace immediately if DOM is ready
  if (document.readyState === 'loading') {
    // DOM is still loading, wait for it
    document.addEventListener('DOMContentLoaded', replaceLogo);
  } else {
    // DOM is already loaded, try immediately
    replaceLogo();
  }
  
  // Also use mutation observer as fallback for dynamic content
  if (document.body) {
    const observer = new MutationObserver(function() {
      if (replaceLogo()) {
        observer.disconnect();
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Disconnect after 5 seconds to avoid memory leaks
    setTimeout(function() {
      observer.disconnect();
    }, 5000);
  }
})();

(function() {
  'use strict';

  // Initialize wellness product functionality
  function initWellnessProduct() {
    const productHeader = document.querySelector('.product-header');
    
    if (!productHeader) {
      return;
    }

    // Get product data from the section
    const sectionData = document.querySelector('[data-section-data]');
    if (!sectionData) {
      return;
    }

    let productData;
    try {
      productData = JSON.parse(sectionData.textContent);
    } catch (e) {
      console.error('Error parsing product data:', e);
      return;
    }

    const product = productData.product;
    if (!product || !product.variants) {
      return;
    }

    // Initialize form/quantity button selection
    initOptionButtons(product);

    // Initialize subscription options (Recharge selling plans)
    initSubscriptionOptions(product, productData.settings ? productData.settings.money_format : null);
    
    // Initialize add to cart
    initAddToCart();
  }

  // Handle option button selection (Form, Quantity, etc.)
  // Note: Active class handling is done by homepage.js
  function initOptionButtons(product) {
    // Form selection buttons - only handle variant selection
    const formSelection = document.querySelector('.product-form-selection');
    if (formSelection) {
      const formButtons = formSelection.querySelectorAll('.product-form-btn');
      const optionIndex = parseInt(formSelection.dataset.optionIndex) || 0;

      formButtons.forEach(button => {
        button.addEventListener('click', function() {
          // Update variant selection (active class handled by homepage.js)
          updateVariantOption(optionIndex, this.dataset.optionValue, product);
        });
      });
    }

    // Quantity selection buttons - only handle variant selection
    const quantitySelection = document.querySelector('.product-quantity-selection');
    if (quantitySelection) {
      const quantityButtons = quantitySelection.querySelectorAll('.quantity-btn');
      const optionIndex = parseInt(quantitySelection.dataset.optionIndex) || 1;

      quantityButtons.forEach(button => {
        button.addEventListener('click', function() {
          // Update variant selection (active class handled by homepage.js)
          updateVariantOption(optionIndex, this.dataset.optionValue, product);
        });
      });
    }
  }

  // Initialize subscription options and selling plan handling
  function initSubscriptionOptions(product, moneyFormat) {
    const subscriptionSelection = document.querySelector('[data-subscription-selection]');
    const optionsContainer = document.querySelector('[data-subscription-options]');
    const sellingPlanInput = document.querySelector('[data-selling-plan]');
    const quantityInput = document.querySelector('[data-product-quantity]');
    const oneTimeOption = document.querySelector('[data-one-time-option]');
    const oneTimeRadio = oneTimeOption ? oneTimeOption.querySelector('input[type="radio"]') : null;
    const oneTimeSelect = document.querySelector('.one-time-quantity-selector');
    const oneTimePrice = document.querySelector('.one-time-price');

    if (!subscriptionSelection || !optionsContainer || !sellingPlanInput) {
      return;
    }

    let activeSellingPlanId = sellingPlanInput.value || null;
    let activeSelection = activeSellingPlanId ? 'subscription' : 'onetime';

    const formatMoney = (cents) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat || window.Shopify.money_format);
      }
      return `$${(cents / 100).toFixed(2)}`;
    };

    const getActiveVariant = () => {
      const selectedOptions = getSelectedOptions();
      return findMatchingVariant(product, selectedOptions) || product.variants[0];
    };

    const updateOneTimePricing = (variant) => {
      if (!variant || !oneTimeSelect || !oneTimePrice) {
        return;
      }

      const basePrice = variant.price || 0;
      Array.from(oneTimeSelect.options).forEach(option => {
        const quantity = parseInt(option.value, 10) || 1;
        const price = basePrice * quantity;
        option.dataset.price = formatMoney(price);
        option.textContent = `${formatMoney(price)} - ${quantity} Bottle${quantity > 1 ? 's' : ''}`;
      });

      const selectedOption = oneTimeSelect.options[oneTimeSelect.selectedIndex];
      if (selectedOption) {
        oneTimePrice.textContent = selectedOption.dataset.price || formatMoney(basePrice);
        if (quantityInput) {
          quantityInput.value = selectedOption.value;
        }
      }
    };

    const renderSubscriptionOptions = (variant) => {
      optionsContainer.innerHTML = '';

      const allocations = variant && variant.selling_plan_allocations ? variant.selling_plan_allocations : [];
      if (!allocations || allocations.length === 0) {
        sellingPlanInput.value = '';
        activeSellingPlanId = null;
        activeSelection = 'onetime';
        if (oneTimeRadio) {
          oneTimeRadio.checked = true;
        }
        return;
      }

      if (variant && variant.requires_selling_plan) {
        activeSelection = 'subscription';
      }

      allocations.forEach((allocation, index) => {
        const plan = allocation.selling_plan;
        console.log('plan', plan);
        const planId = plan ? plan.id : null;
        const planName = plan ? plan.name : 'Subscription';
        const description = plan && plan.options ? plan.options.map(option => `${option.name} ${option.value}`.trim()).join(' • ') : '';
        const price = allocation.price || 0;
        const compareAtPrice = variant ? variant.price : null;
        const isActive = (activeSelection === 'subscription' && activeSellingPlanId ? planId === Number(activeSellingPlanId) : index === 0 && activeSelection === 'subscription');
        const inputId = `subscription-plan-${planId}`;

        const optionMarkup = document.createElement('div');
        optionMarkup.className = 'subscription-option';
        optionMarkup.innerHTML = `
          <input type="radio" name="subscription" id="${inputId}" value="${planId}" class="subscription-radio" ${isActive ? 'checked' : ''}>
          <label for="${inputId}" class="subscription-label ${isActive ? 'subscription-label--active' : ''}" data-selling-plan-id="${planId}">
            <div class="subscription-content">
              <div class="subscription-header-content">
                <h4 class="subscription-name">${planName}</h4>
                <p class="subscription-description">1 unit delivered every ${(index + 1) * 30} days</p>
              </div>
              <div class="subscription-pricing">
                ${compareAtPrice ? `<span class="subscription-price-old">${formatMoney(compareAtPrice)}</span>` : ''}
                <span class="subscription-price-new">${formatMoney(price)}</span>
              </div>
            </div>
          </label>
        `;

        optionsContainer.appendChild(optionMarkup);

        if (isActive && planId) {
          sellingPlanInput.value = planId;
          activeSellingPlanId = planId;
        }
      });

      if (activeSelection === 'subscription' && activeSellingPlanId && oneTimeRadio) {
        oneTimeRadio.checked = false;
      }
    };

    const handleSubscriptionSelection = (event) => {
      const target = event.target;
      if (!target || target.name !== 'subscription') {
        return;
      }

      if (target.value === 'onetime') {
        sellingPlanInput.value = '';
        activeSellingPlanId = null;
        activeSelection = 'onetime';

        const subscriptionRadios = optionsContainer.querySelectorAll('input[name="subscription"]');
        subscriptionRadios.forEach(radio => {
          radio.checked = false;
        });
        return;
      }

      const selectedPlanId = parseInt(target.value, 10);
      if (!Number.isNaN(selectedPlanId)) {
        sellingPlanInput.value = selectedPlanId;
        activeSellingPlanId = selectedPlanId;
        activeSelection = 'subscription';

        if (oneTimeRadio) {
          oneTimeRadio.checked = false;
        }
      }
    };

    const updateActiveLabel = () => {
      const subscriptionLabels = subscriptionSelection.querySelectorAll('.subscription-label');
      subscriptionLabels.forEach(label => label.classList.remove('subscription-label--active'));
      const oneTimeLabels = subscriptionSelection.querySelectorAll('.one-time-label');
      oneTimeLabels.forEach(label => label.classList.remove('one-time-label--active'));

      const checkedRadio = subscriptionSelection.querySelector('input[name="subscription"]:checked');
      if (checkedRadio) {
        const checkedLabel = subscriptionSelection.querySelector(`label[for="${checkedRadio.id}"]`);
        if (checkedLabel) {
          if (checkedLabel.classList.contains('one-time-label')) {
            checkedLabel.classList.add('one-time-label--active');
          } else {
            checkedLabel.classList.add('subscription-label--active');
          }
        }
      }
    };

    const initialVariant = getActiveVariant();
    updateOneTimePricing(initialVariant);
    renderSubscriptionOptions(initialVariant);
    updateActiveLabel();

    if (oneTimeSelect) {
      oneTimeSelect.addEventListener('change', () => {
        const selectedOption = oneTimeSelect.options[oneTimeSelect.selectedIndex];
        if (selectedOption && oneTimePrice) {
          oneTimePrice.textContent = selectedOption.dataset.price;
        }
        if (selectedOption && quantityInput) {
          quantityInput.value = selectedOption.value;
        }
      });
    }

    subscriptionSelection.addEventListener('change', (event) => {
      handleSubscriptionSelection(event);
      updateActiveLabel();
    });

    document.addEventListener('variant:change', (event) => {
      const variant = event.detail && event.detail.variant ? event.detail.variant : getActiveVariant();
      updateOneTimePricing(variant);
      renderSubscriptionOptions(variant);
      updateActiveLabel();
    });
  }

  // Update variant option and find matching variant
  function updateVariantOption(optionIndex, optionValue, product) {
    // Get all selected option values
    const selectedOptions = getSelectedOptions();
    
    // Find matching variant
    const matchingVariant = findMatchingVariant(product, selectedOptions);
    
    if (matchingVariant) {
      // Update the hidden variant select
      const variantSelect = document.querySelector('[data-variants]');
      if (variantSelect) {
        variantSelect.value = matchingVariant.id;
        
        // Trigger change event to update price, availability, etc.
        const changeEvent = new Event('change', { bubbles: true });
        variantSelect.dispatchEvent(changeEvent);
        
        // Also trigger custom event for other listeners
        const customEvent = new CustomEvent('variant:change', {
          detail: { variant: matchingVariant }
        });
        document.dispatchEvent(customEvent);
      }
    }
  }

  // Get all currently selected option values
  function getSelectedOptions() {
    const selectedOptions = [];
    
    // Check if this is a sports product (has flavor selection)
    const flavorSelection = document.querySelector('.product-flavor-selection');
    const customSelect = document.querySelector('.custom-select');
    
    if (flavorSelection) {
      // Sports product structure
      const formSelection = document.querySelector('.product-form-selection');
      if (formSelection) {
        const activeFormBtn = formSelection.querySelector('.product-form-btn.active');
        if (activeFormBtn) {
          selectedOptions[0] = activeFormBtn.dataset.optionValue;
        }
      }
      
      const activeFlavorBtn = flavorSelection.querySelector('.flavor-buttons .quantity-btn.active');
      if (activeFlavorBtn) {
        selectedOptions[1] = activeFlavorBtn.dataset.optionValue;
      }
      
      if (customSelect) {
        const nativeSelect = document.querySelector('.flavor-dropdown-native');
        if (nativeSelect && nativeSelect.value) {
          selectedOptions[2] = nativeSelect.value;
        }
      }
    } else {
      // Wellness product structure (original)
      const formSelection = document.querySelector('.product-form-selection');
      const quantitySelection = document.querySelector('.product-quantity-selection');
      
      if (formSelection) {
        const activeFormBtn = formSelection.querySelector('.product-form-btn.active');
        if (activeFormBtn) {
          selectedOptions[0] = activeFormBtn.dataset.optionValue;
        }
      }
      
      if (quantitySelection) {
        const activeQuantityBtn = quantitySelection.querySelector('.quantity-btn.active');
        if (activeQuantityBtn) {
          selectedOptions[1] = activeQuantityBtn.dataset.optionValue;
        }
      }
    }
    
    return selectedOptions;
  }

  // Find matching variant based on selected options
  function findMatchingVariant(product, selectedOptions) {
    if (!product || !product.variants) {
      return null;
    }

    return product.variants.find(variant => {
      if (!variant.options) {
        return false;
      }
      
      // Check if all selected options match variant options
      return selectedOptions.every((selectedOption, index) => {
        // If no option selected at this index, skip check
        if (!selectedOption) {
          return true;
        }
        // Check if variant option matches selected option
        return variant.options[index] === selectedOption;
      });
    });
  }

  // Handle Add to Cart button
  function initAddToCart() {
    const addToCartBtn = document.querySelector('[data-add-to-cart]');
    const productForm = document.querySelector('[data-product-form]');
    
    if (addToCartBtn && productForm) {
      addToCartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Get selected variant
        const variantSelect = productForm.querySelector('[data-variants]');
        if (!variantSelect || variantSelect.value === 'not-selected') {
          alert('Please select a variant');
          return;
        }
        
        // Submit the form
        productForm.submit();
      });
    }
  }

  // Initialize sports product functionality
  function initSportsProduct() {
    const sectionData = document.querySelector('[data-section-type="static-product-sports-header"][data-section-data]');
    
    if (!sectionData) {
      return;
    }

    let productData;
    try {
      productData = JSON.parse(sectionData.textContent);
    } catch (e) {
      console.error('Error parsing product data:', e);
      return;
    }

    const product = productData.product;
    if (!product || !product.variants) {
      return;
    }

    // Initialize custom dropdown
    initCustomDropdown(product);
    
    // Initialize flavor buttons
    initFlavorButtons(product);
    
    // Initialize form buttons
    initFormButtons(product);
    
    // Initialize add to cart
    initAddToCart();
  }

  // Initialize custom dropdown for sports products
  function initCustomDropdown(product) {
    const customSelect = document.querySelector('.custom-select');
    if (!customSelect) {
      return;
    }

    const trigger = customSelect.querySelector('.custom-select__trigger');
    const options = customSelect.querySelector('.custom-select__options');
    const nativeSelect = document.querySelector('.flavor-dropdown-native');
    const customOptions = options.querySelectorAll('.custom-option');

    // Handle native select change (if changed directly)
    if (nativeSelect) {
      nativeSelect.addEventListener('change', function() {
        const value = this.value;
        const optionIndex = parseInt(this.dataset.optionIndex) || 2;
        
        // Update custom select display
        const matchingOption = Array.from(customOptions).find(opt => opt.dataset.value === value);
        if (matchingOption && trigger) {
          trigger.querySelector('span').textContent = matchingOption.textContent;
          customOptions.forEach(opt => opt.classList.remove('selected'));
          matchingOption.classList.add('selected');
        }
        
        // Update variant selection
        updateVariantOption(optionIndex, value, product);
      });
    }

    // Toggle dropdown
    if (trigger) {
      trigger.addEventListener('click', function(e) {
        e.stopPropagation();
        customSelect.classList.toggle('custom-select--open');
      });
    }

    // Handle option selection
    customOptions.forEach(option => {
      option.addEventListener('click', function() {
        const value = this.dataset.value;
        
        // Update native select
        if (nativeSelect) {
          nativeSelect.value = value;
          const changeEvent = new Event('change', { bubbles: true });
          nativeSelect.dispatchEvent(changeEvent);
        }

        // Update custom select display
        trigger.querySelector('span').textContent = this.textContent;
        
        // Update selected state
        customOptions.forEach(opt => opt.classList.remove('selected'));
        this.classList.add('selected');
        
        // Close dropdown
        customSelect.classList.remove('custom-select--open');
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function(e) {
      if (!customSelect.contains(e.target)) {
        customSelect.classList.remove('custom-select--open');
      }
    });
  }

  // Initialize flavor buttons for sports products
  function initFlavorButtons(product) {
    const flavorSelection = document.querySelector('.product-flavor-selection');
    if (!flavorSelection) {
      return;
    }

    const flavorButtons = flavorSelection.querySelectorAll('.flavor-buttons .quantity-btn');
    const optionIndex = parseInt(flavorSelection.dataset.optionIndex) || 1;

    flavorButtons.forEach(button => {
      button.addEventListener('click', function() {
        // Update variant selection (active class handled by homepage.js)
        updateVariantOption(optionIndex, this.dataset.optionValue, product);
      });
    });
  }

  // Initialize form buttons for sports products
  function initFormButtons(product) {
    const formSelection = document.querySelector('.product-form-selection');
    if (!formSelection) {
      return;
    }

    const formButtons = formSelection.querySelectorAll('.product-form-btn');
    const optionIndex = parseInt(formSelection.dataset.optionIndex) || 0;

    formButtons.forEach(button => {
      button.addEventListener('click', function() {
        // Update variant selection (active class handled by homepage.js)
        updateVariantOption(optionIndex, this.dataset.optionValue, product);
      });
    });
  }


  // Initialize Gallery Popup
  function initGalleryPopup() {
    const galleryImages = document.querySelectorAll('.gallery-image');
    const galleryPopup = document.getElementById('gallery-popup');
    
    if (!galleryPopup || galleryImages.length === 0) {
      return;
    }

    const popupImage = document.getElementById('gallery-popup-image');
    const popupCurrent = document.getElementById('gallery-popup-current');
    const popupTotal = document.getElementById('gallery-popup-total');
    const closeBtn = galleryPopup.querySelector('.gallery-popup__close');
    const prevBtn = galleryPopup.querySelector('.gallery-popup__nav--prev');
    const nextBtn = galleryPopup.querySelector('.gallery-popup__nav--next');
    const overlay = galleryPopup.querySelector('.gallery-popup__overlay');

    let currentIndex = 0;
    const totalImages = galleryImages.length;

    // Set total count
    if (popupTotal) {
      popupTotal.textContent = totalImages;
    }

    // Open popup
    function openPopup(index) {
      currentIndex = index;
      updatePopupImage();
      galleryPopup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('gallery-popup-open');
      updateNavigationButtons();
    }

    // Close popup
    function closePopup() {
      galleryPopup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('gallery-popup-open');
    }

    // Update popup image
    function updatePopupImage() {
      const image = galleryImages[currentIndex];
      if (image && popupImage) {
        popupImage.src = image.dataset.gallerySrc || image.src;
        popupImage.alt = image.dataset.galleryAlt || image.alt;
        
        // Reset animation
        popupImage.style.animation = 'none';
        setTimeout(() => {
          popupImage.style.animation = 'galleryFadeIn 0.3s ease';
        }, 10);
      }

      if (popupCurrent) {
        popupCurrent.textContent = currentIndex + 1;
      }

      updateNavigationButtons();
    }

    // Update navigation buttons
    function updateNavigationButtons() {
      if (prevBtn) {
        prevBtn.disabled = currentIndex === 0;
      }
      if (nextBtn) {
        nextBtn.disabled = currentIndex === totalImages - 1;
      }
    }

    // Navigate to previous image
    function prevImage() {
      if (currentIndex > 0) {
        currentIndex--;
        updatePopupImage();
      }
    }

    // Navigate to next image
    function nextImage() {
      if (currentIndex < totalImages - 1) {
        currentIndex++;
        updatePopupImage();
      }
    }

    // Add click handlers to gallery images
    galleryImages.forEach((image, index) => {
      image.addEventListener('click', function() {
        openPopup(index);
      });
    });

    // Close button
    if (closeBtn) {
      closeBtn.addEventListener('click', closePopup);
    }

    // Overlay click to close
    if (overlay) {
      overlay.addEventListener('click', closePopup);
    }

    // Navigation buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        prevImage();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        nextImage();
      });
    }

    // Keyboard navigation
    document.addEventListener('keydown', function(e) {
      if (galleryPopup.getAttribute('aria-hidden') === 'false') {
        if (e.key === 'Escape') {
          closePopup();
        } else if (e.key === 'ArrowLeft') {
          prevImage();
        } else if (e.key === 'ArrowRight') {
          nextImage();
        }
      }
    });

    // Prevent popup content clicks from closing
    const popupContainer = galleryPopup.querySelector('.gallery-popup__container');
    if (popupContainer) {
      popupContainer.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initWellnessProduct();
      initSportsProduct();
      initGalleryPopup();
    });
  } else {
    initWellnessProduct();
    initSportsProduct();
    initGalleryPopup();
  }
})();
